<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
          <span   [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <div  *ngIf="now=='2'" style="margin-top:10px">
        <button data-toggle="modal" (click)="get_default()" data-target=".bd-example-modal-xl" class="btn btn-primary mb-3">新增活動</button>
        <app-table-v2 [type]="1" [data]="data"  [tcontent]="tcontent" *ngIf="data.length>0">

            <ng-template let-post #operation_dk>

                <div *ngIf="post.key == 'gg'">
                    <a href="javascript:void(0)" title="點我設定"  (click)="edit_data=post.val;" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-wrench"></i>
                    </a>
                </div>

            </ng-template>

        </app-table-v2>
        <div *ngIf="data.length==0">無資料</div>
    </div>

    <div *ngIf="now=='3'">
        <div *ngIf="tool_obj.active_id*1!=-1" style="display: flex;">
            <div style="margin-right: 1%;">
                <select class="form-control"
                    style="width: 160px;display: inline-block;margin-right: 10px;"
                    [(ngModel)]="tool_obj.active_id"
                    (change)="default_model()"
                >
                    <option *ngFor="let item of active_option" [ngValue]="item.id">{{item.name}}</option>
                </select>

                <select class="form-control"
                    style="width: 160px; display: inline-block; margin-right: 10px;"
                    [(ngModel)]="tool_obj.searchFileType"
                    (change)="default_model()"
                >
                    <option *ngFor="let item of active_option_type" [ngValue]="item.id">{{item.name}}</option>
                </select>

                <select class="form-control"
                    style="width: 160px;display: inline-block;"
                    [(ngModel)]="tool_obj.ranking_active_type_id"
                    (change)="default_model()"
                    *ngIf="now == '3' && rank_type == 0"
                >
                    <option *ngFor="let item of ranking_active_type" [ngValue]="item.id">{{item.name}}</option>
                </select>

            </div>

            <div style="display: flex;" *ngIf="now == '3' && rank_type == 0">
                <div>
                    <input (keyup.enter)="default_model()" type="text" [(ngModel)]="search_model" style="width: 215px;height: 44px;display:inline-block" class="form-control" placeholder="請輸入用戶名">
                </div>
                <div>
                    <button class="btn btn-primary" (click)="default_model()" style="height: 44px;">查詢</button>
                </div>
            </div>

        </div>

        <div style="margin: 15px 0px;">
            <button class="btn" (click)="rank_type=1;init_list();" [ngClass]="rank_type==1?'btn-success':'btn-secondary'" style="margin-right: 1%;">用戶排名</button>
            <button class="btn" (click)="rank_type=0;init_list();" [ngClass]="rank_type==0?'btn-success':'btn-secondary'">動態排名</button>
            <span *ngIf="now=='3'" style="margin-left: 10px; color: #999; font-size: 13px;">
                💡 每日統計時間為早上 5 點
            </span>
        </div>

        <div class="team-scroller" *ngIf="group.length > 0">
            <div class="team-card" *ngFor="let item of group;">
                <h3>{{item.vendor_name}}</h3>
                <p>符合張數：<span>{{item.ok_num}}</span></p>
                <p>最後總分：<span>{{item.all}}</span></p>
            </div>
        </div>



        <app-table-v2 [type]="1" [data]="data"  [tcontent]="tcontent" *ngIf="data.length > 0" (sortdata)="handlesortdata($event)">
            <ng-template let-post  let-i="index" #operation_dk>
                <div *ngIf="post.key == 'ok_num'">
                    <!-- <pre>{{ post | json }}</pre> -->
                    <div *ngIf="rank_type == 0">
                        <video  *ngIf="post.val.type * 1 == 2" class="m-3"  src="{{post.val.url}}"   style="width:140px;height: 20px;" controls></video>
                        <img loading="lazy" *ngIf="post.val.type * 1 == 3" style="width: 20%;" src="{{post.val.url}}">
                        <video  *ngIf="post.val.type * 1 == 4" class="m-3"  src="{{post.val.url}}"  style="width:170px" controls></video>
                    </div>
                    <div *ngIf="rank_type == 1"
                        (click)="pageobj2.page = 0; edit_data = post.val; view_detail()"
                        data-toggle="modal"
                        data-target=".bd-example-modal-xl"
                        class="card-text"
                    >
                        <span class="show_it">{{post.val.ok_num | number}}</span>
                    </div>
                </div>
                <div *ngIf="post.key == 'weighted'">
                    <div *ngIf="!post.editing && post.key == 'weighted'" (click)="post.editing = true" style="cursor: pointer;">
                        {{ post.val.weighted }}
                    </div>
                    <input *ngIf="post.editing && post.key == 'weighted'" type="number" [(ngModel)]="post.val.weighted" step="0.01" min="1" (blur)="post.editing = false;changeNum(post.val)">
                </div>

                <div *ngIf="post.key == 'gg'">
                    <button class="tag btn btn-secondary" (click)="post.val.is_enable=1;change_type(post.val)" [ngClass]="post.val.is_enable==1?'btn-success':'btn-secondary'">符合</button>
                    <button class="tag btn btn-secondary" (click)="post.val.is_enable=-1;change_type(post.val)" [ngClass]="post.val.is_enable==-1?'btn-success':'btn-secondary'">不符合</button>
                </div>
            </ng-template>

        </app-table-v2>


        <!-- <table class="table table-responsive-sm" *ngIf="data.length>0">
            <thead>
             <tr class="table-primary">
               <th style="width:5%">名稱</th>
               <th style="width:5%">大頭</th>
               <th style="width:5%">
                    <span *ngIf="rank_type==1">符合媒體數</span>
                    <span *ngIf="rank_type==0">媒體</span>
               </th>
               <th style="width:5%">目前總分數</th>
             </tr>
             </thead>
             <tbody>
             <tr *ngFor="let item of data; let key = index"  class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                <td>
                    <a target="_blank" href="{{link}}/useractive/{{item.uid}}"><span class="user_identity_{{item.identity}}">
                    {{item.name}}
                    <div *ngIf="item.v_name && item.v_name.length>0">({{item.v_name}})</div>
                    </span></a>
                </td>
               <td> <img loading="lazy" style="height: 100px;" [src]="item.profile_pic"></td>
               <td>
                 <div *ngIf="rank_type==0">
                    <video  *ngIf="item.type*1==2" class="m-3"  src="{{item.url}}"   style="width:140px;height: 20px;" controls></video>
                    <img loading="lazy" *ngIf="item.type*1==3" style="width: 100%;" src="{{item.url}}">
                    <video  *ngIf="item.type*1==4" class="m-3"  src="{{item.url}}"  style="width:170px" controls></video>
                 </div>
                 <div *ngIf="rank_type==1" (click)="pageobj2.page=0;edit_data=item;view_detail()"
                 data-toggle="modal"
                 data-target=".bd-example-modal-xl" class="card-text"><span class="show_it">{{item.ok_num|number}}</span></div>
               </td>
               <td>{{item.all|number}}</td>
             </tr>
             </tbody>
        </table> -->

        <div *ngIf="data.length==0||tool_obj.active_id*1==-1">無資料</div>
    </div>


    <div *ngIf="now=='1'">

        <div *ngIf="tool_obj.active_id*1!=-1">

            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.active_id"
            (change)="defaultpage();init_list();"
            >
            <option *ngFor="let item of active_option" [ngValue]="item.id">{{item.name}}</option>
            </select>



            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.lock_status"
            (change)="defaultpage();init_list();"
            >
            <option *ngFor="let item of lock_option_list" [ngValue]="item.id">{{item.name}}</option>
            </select>
            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.gender_action"
            (change)="defaultpage();init_list();"
            >
            <option *ngFor="let item of gender_option_list" [ngValue]="item.id">{{item.name}}</option>
            </select>
            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.identity_action"
            (change)="defaultpage();init_list();"
            >
            <option *ngFor="let item of identity_option_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.chosen_action"
            (change)="defaultpage();init_list();"
            *ngIf="now*1<3"
            >
            <option *ngFor="let item of chosen_option_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.type"
            (change)="defaultpage();init_list();"
            *ngIf="now*1<3"
            >
            <option default disabled value="-2">顯示類型</option>
            <option *ngFor="let item of type_option_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <select class="form-control"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="tool_obj.active_type_id"
            (change)="defaultpage();init_list();"
            *ngIf="now*1<3"
            >
            <option *ngFor="let item of active_type" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <input type="text" placeholder="查詢使用者"  style="width: 160px;display: inline-block;"
            class="form-control"  [(ngModel)]="tool_obj.search_model"
            (keyup.enter)="defaultpage();init_list()">
            <button class="btn btn-primary" (click)="init_list()">確認</button>
            <div>
                <button class="btn btn-primary" style="margin: 4px;" (click)="choose_all(1)">全選</button>
                <button class="btn btn-primary" style="margin: 4px;" (click)="choose_all(0)">取消全選</button>
                <div class="tips">預設都不操作就送出會是不符合</div>
            </div>
        </div>
        <hr>
        <div *ngIf="tool_obj.active_id*1!=-1">
            <div *ngFor="let item of data;let i = index"  class="card text-white bg-light mb-3 info_item {{tool_obj.process_list.indexOf(item.id)!=-1?'choose_item':''}} {{alert_list.indexOf(item.id)!=-1?'alert_item':''}} "  >
                    <div class="tagntndiv" style="height: 43px;">
                        <button class="tag btn btn-secondary" *ngIf="item.is_enable==6">盜圖</button>
                        <button class="tag btn btn-success" *ngIf="item.check_result==1">符合</button>
                        <button class="tag btn btn-secondary" *ngIf="item.check_result==-1">不符合</button>
                    </div>
                    <div class="info_itemsss">
                        <div class="card-header" (click)="choose_item(item);alert_item(item)"  style="cursor: pointer;">
                            <img loading="lazy" *ngIf="item.type*1==3" style="width: 100%;" src="{{item.url}}">
                            <img loading="lazy" *ngIf="item.type*1==4" style="width: 100%;" src="{{item.preview_url}}">
                        </div>
                        <div class="card-body">
                            <div class="card-text">
                                <span class="{{item.gender==1?'boy':'girl'}}">用戶：</span><a target="_blank" href="{{link}}/useractive/{{item.uid}}"><span class="user_identity_{{item.identity}}">{{item.name}}
                                    <div *ngIf="item.v_name && item.v_name.length>0">({{item.v_name}})</div>
                                </span></a>
                            </div>
                            <div class="card-text">
                                鑽石：
                                <span *ngIf="item.diamond>=0">{{item.diamond?item.diamond:0}}</span>
                                <span *ngIf="item.diamond<0">男生上鎖</span>
                            </div>
                            <div class="card-text">
                                動態描述：{{item.description}}
                            </div>
                            <div class="card-text">
                                動態類型：{{item.type==4?'影片':'圖片'}}
                            </div>
                            <div class="card-text">
                                觀看次數：{{item.view?item.view:0}}
                            </div>
                            <div class="card-text">
                                解鎖數：{{item.view?item.delock_num:0}}
                            </div>
                            <div class="card-text">
                                愛心數：{{item.view?item.love:0}}
                            </div>
                            <div class="card-text">
                                留言數：{{item.view?item.comment_num:0}}
                            </div>
                            <div class="card-text">
                                <a href="{{item.url}}" target="_blank">分頁觀看</a>
                            </div>
                            <div class="card-text" *ngIf="item.check_result == 1" style="display: flex;">
                                <div for="point">分數加權：</div>
                                <input type="number" id="point"  name="point"  style="width: 110px;"  [(ngModel)]="item.point" min="1" step="0.01" (keypress)="validateInput($event)"   (blur)="ensureMinValue(i)">
                            </div>
                        </div>
                    </div>
            </div>
        </div>

        <div *ngIf="data.length==0||tool_obj.active_id*1==-1">無資料</div>
        <div class="back-to-top show_mb_data">
            <div style="display: flex;flex-flow: column;">
                <div style="display: flex;flex-direction: column;align-items: revert;">
                    <button *ngFor="let item of process_option_list" (click)="middle_save(item)" style="margin-bottom: 5px;" class="btn btn-primary">{{item.name}}</button>
                </div>
                <div><button class="btn btn-primary" (click)="save()">送出</button></div>
                <a style="margin: 10px;cursor: pointer;text-align: center;" (click)="go_top()" id="go_top" onclick="return false">
                    <i style="font-size: 1.73em;" class="fas fa-arrow-circle-up"></i>
                </a>
            </div>
        </div>
    </div>


    <div
        *ngIf="edit_data"
        class="modal fade bd-example-modal-xl" tabindex="-1"
        role="dialog"  data-keyboard="false" data-backdrop="static"
        aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
    >
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h5 *ngIf="now!='3'" class="modal-title">{{edit_data.id==-1?'新增':'修改'}}</h5>
                        <h5 *ngIf="now=='3'" class="modal-title">確認</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body" *ngIf="now==3">
                        <div class="user_edit_block form-group" *ngFor="let item of edit_data.data;let bi = index">
                            <div class="item-container">
                                <label class="col-sm-4 col-form-label" *ngIf="item.type == '2'">
                                    <video class="m-3"  src="{{item.url}}"  style="width:140px;height: 20px;" controls></video>
                                    <div>審核者：{{item.emp_name}}</div>
                                </label>
                                <label class="col-sm-4 col-form-label" *ngIf="item.type == '3'">
                                    <img loading="lazy" style="height: 80px;" src="{{item.url}}">
                                    <div>審核者：{{item.emp_name}}</div>
                                </label>
                                <label class="col-sm-4 col-form-label" *ngIf="item.type == '4'">
                                    <video class="m-3"  src="{{item.url}}"  style="width:170px"controls></video>
                                    <div>審核者：{{item.emp_name}}</div>
                                </label>
                                <button class="tag btn btn-secondary" (click)="item.is_enable=1" [ngClass]="item.is_enable==1?'btn-success':'btn-secondary'">符合</button>
                                <button class="tag btn btn-secondary" (click)="item.is_enable=-1" [ngClass]="item.is_enable==-1?'btn-success':'btn-secondary'">不符合</button>
                            </div>
                        </div>
                        <app-pagnation (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation>
                    </div>
                    <div class="modal-body" *ngIf="now!=3">
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">活動名</label>
                            <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.description">
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">類型</label>
                            <select class="form-control"
                                style="width: 160px;display: inline-block;"
                                [(ngModel)]="edit_data.type"
                            >
                                <option *ngFor="let item of type_list" [ngValue]="item.id">{{item.name}}</option>
                            </select>
                        </div>
                        <div class="user_edit_block form-group" *ngIf="edit_data.type == '0'">
                            <label class="col-sm-2 col-form-label">項目</label>
                            <select class="form-control"
                                style="width: 160px;display: inline-block;"
                                [(ngModel)]="edit_data.target_type"
                                (change)="init_list()"
                            >
                                <option *ngFor="let item of target_type_list" [ngValue]="item.id">{{item.name}}</option>
                            </select>
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">活動日</label>
                            <input type="text"
                            *ngIf="time"
                            class="form-control"
                            ngxDaterangepickerMd
                            [(ngModel)]="time"
                            [autoApply]="true"
                            [ranges]="ranges" [alwaysShowCalendars]="true"
                            [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                            [opens]="'right'"
                            [minDate]="time.start_dt"
                            [maxDate]='time.end_dt'
                            (change)="onRangeSelected(1,$event)"
                            (blur)="onDateTyped($event)"
                            style="width: 260px;display: inline-block;margin-right: 16px;"
                            >
                        </div>
                        <div class="user_edit_block form-group">
                            <label class="col-sm-2 col-form-label">狀態</label>
                            <button [ngClass]="edit_data.status==0?'btn-danger':'btn-secondary'"  (click)="edit_data.status=0" class="btn" style="margin-right: 1%;" >下架</button>
                            <button [ngClass]="edit_data.status==1?'btn-danger':'btn-secondary'" (click)="edit_data.status=1" class="btn" >啟用</button>
                        </div>
                    </div>



                    <!-- Modal footer -->
                    <div class="modal-footer" *ngIf="now!='3'">
                        <button id="ModalClose" type="button" (click)="add()" *ngIf="now=='2'"  class="btn btn-primary" data-dismiss="modal">{{edit_data.id==-1?'新增':'修改'}}</button>
                        <button id="ModalClose" type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
                    </div>
                    <div class="modal-footer" *ngIf="now=='3'">
                        <button id="ModalClose" type="button" (click)="save_detail()"  class="btn btn-primary" data-dismiss="modal">確認修改</button>
                        <button id="ModalClose" type="button" (click)="view_detail()"  class="btn btn-danger" data-dismiss="modal">取消</button>
                    </div>
                </div>
            </div>
        </div>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    <app-spinner [loading]="loading"></app-spinner>
</div>
